import MUIDialogContent from '@mui/material/DialogContent';
import MUIDialogContentText from '@mui/material/DialogContentText';

export const DialogContent = MUIDialogContent;
export const DialogContentText = MUIDialogContentText;
